module.exports = __webpack_public_path__ + "static/media/pu-click.a2424590.ogg";